import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useAuthContext } from "../contexts/AuthContext";

export default function MaintenanceGuard() {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [shouldRender, setShouldRender] = useState(false);
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);
  const [checkingMaintenance, setCheckingMaintenance] = useState(true);

  useEffect(() => {
    const docRef = doc(db, "systemSettings", "general");
    
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setMaintenanceEnabled(data.maintenance?.enabled || false);
      } else {
        setMaintenanceEnabled(false);
      }
      setCheckingMaintenance(false);
    }, (error) => {
      console.error("Error listening to maintenance settings:", error);
      setMaintenanceEnabled(false);
      setCheckingMaintenance(false);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (loading || checkingMaintenance) {
      return;
    }

    if (!maintenanceEnabled) {
      setShouldRender(true);
      return;
    }

    const isMaintenancePage = location.pathname === "/maintenance";
    const isAdmin = user?.email === "viitamint@gmail.com";

    if (isAdmin) {
      setShouldRender(true);
      return;
    }

    if (!isMaintenancePage) {
      navigate("/maintenance", { replace: true });
      return;
    }

    setShouldRender(true);
  }, [loading, checkingMaintenance, maintenanceEnabled, user, location.pathname, navigate]);

  if (loading || checkingMaintenance || !shouldRender) {
    return null;
  }

  return <Outlet />;
}
